import { forwardRef } from 'react';

import { Icon, IconProps } from '@/component-library/Icon';

const GLMR = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon {...props} ref={ref} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <title>GLMR</title>
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'>
      <g clipPath='url(#glmr-a)'>
        <circle cx='12' cy='12' r='11.5' fill='#171717' stroke='#EC1C79' />
        <g clipPath='url(#glmr-b)'>
          <path
            fill='#5FC0C1'
            d='M15.234 5.44c1.816.772 3.064 2.645 2.95 4.518H8.426c0-1.212.453-2.534 1.361-3.416C11.035 5 13.418 4.56 15.234 5.441Z'
          />
          <path
            fill='#E1177C'
            d='M15.007 17.45c.227 0 .34.11.34.22s-.113.22-.34.22h-5.22c-.227 0-.34-.11-.34-.22s.113-.22.34-.22h5.22ZM8.652 18c.227 0 .34-.11.34-.33 0-.22-.113-.331-.34-.331-.226 0-.34.11-.34.33 0 .22.114.331.34.331ZM11.83 16.678c.227 0 .34-.11.34-.33 0-.22-.113-.331-.34-.331-.227 0-.34.11-.34.33 0 .22.113.331.34.331ZM17.957 16.017c.227 0 .34.11.34.33 0 .22-.113.331-.34.331h-5.106c-.227 0-.34-.11-.34-.33 0-.22.113-.331.34-.331h5.106ZM5.021 15.356c.227 0 .34-.11.34-.33 0-.22-.113-.331-.34-.331-.227 0-.34.11-.34.33 0 .22.227.33.34.33ZM10.128 14.695c.227 0 .34.11.34.33 0 .22-.113.33-.34.33H5.929c-.227 0-.34-.11-.34-.33 0-.22.113-.33.34-.33h4.199ZM19.66 14.695c.227 0 .34.11.34.33 0 .22-.113.33-.34.33h-8.398c-.226 0-.34-.11-.34-.33 0-.22.114-.33.34-.33h8.398ZM18.07 13.373c.228 0 .341.11.341.33 0 .22-.113.33-.34.33H7.745c-.114.111-.34-.11-.34-.33 0-.22.113-.33.34-.33H18.07ZM6.61 14.144c.227 0 .34-.11.34-.33 0-.22-.113-.441-.34-.441-.227 0-.34.22-.34.33 0 .11.113.441.34.441ZM15.915 12.161c.227 0 .34.11.34.33 0 .22-.113.331-.34.331H5.589c-.114 0-.34-.11-.34-.33 0-.22.113-.331.34-.331h10.326ZM4.34 12.822c.227 0 .34-.11.34-.33 0-.22-.113-.331-.34-.331-.227 0-.34.11-.34.33 0 .22.113.331.34.331ZM6.61 11.5c.227 0 .34-.11.34-.33 0-.22-.113-.331-.34-.331-.227 0-.34.22-.34.33 0 .22.113.331.34.331ZM19.092 10.839c.227 0 .34.11.34.33 0 .22-.113.331-.34.331H7.858c-.227 0-.34-.11-.34-.33 0-.22.113-.331.34-.331h11.234Z'
          />
        </g>
      </g>
      <defs>
        <clipPath id='glmr-a'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
        <clipPath id='glmr-b'>
          <path fill='#fff' d='M4 5h16v13H4z' />
        </clipPath>
      </defs>
    </svg>
  </Icon>
));

GLMR.displayName = 'GLMR';

export { GLMR };
